import TimelineAction from "@app/enum/TimelineAction";
import TimelineEvent, { RawTimelineEvent } from "@app/types/events/TimelineEvent";
import splitTimelineActions from "@app/util/timeline/splitTimelineActions";

// One raw audit row carries a comma-joined action string ("record added,location changed"); it fans
// out into one event per action present in `validActions`. When a row is BOTH a completed activity and
// a record update, keep only the completed-activity facet (it renders as the check-in card). Callers
// inject their own valid-action set — the dashboard timeline and Field View accept different subsets
// (Field View additionally surfaces app-start / find-me location pings) — so the rule lives once here.
const normalizeRawTimelineEvents = (
  rawEvents: RawTimelineEvent[],
  validActions: ReadonlySet<TimelineAction>
): TimelineEvent[] => {
  const result: TimelineEvent[] = [];
  rawEvents.forEach((item) => {
    const actions = splitTimelineActions(item.action);
    actions.forEach((action) => {
      if (!validActions.has(action)) {
        return;
      }
      if (
        actions.includes(TimelineAction.ACTIVITY_COMPLETED) &&
        actions.includes(TimelineAction.RECORD_UPDATED) &&
        action !== TimelineAction.ACTIVITY_COMPLETED
      ) {
        return;
      }
      result.push({ ...item, action, originalAction: item.action } as TimelineEvent);
    });
  });
  return result;
};

export default normalizeRawTimelineEvents;
